import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const renderingClassName = 'base-dialog-layout-rendering';
const mountedClassName = 'base-dialog-layout-mounted';
const closedClassName = 'base-dialog-layout-close';

export default function BaseDialogLayoutAppearHoc(Component) {
  class BaseDialogLayoutAppearWrapper extends React.PureComponent {
    constructor(props) {
      super(props);

      this.state = {
        className: renderingClassName,
      };
    }

    componentDidMount() {
      setTimeout(() => {
        this.setState({
          className: mountedClassName,
        });
      }, 0);
    }

    render() {
      const { className: propsClassName, closed, animated, ...otherProps } = this.props;
      const { className: stateClassName } = this.state;

      return (
        <Component
          closed={closed}
          {...otherProps}
          className={classnames(
            propsClassName,
            animated
              ? {
                  [stateClassName]: !closed,
                  [closedClassName]: closed,
                }
              : mountedClassName
          )}
        />
      );
    }
  }

  BaseDialogLayoutAppearWrapper.defaultProps = {
    animated: true,
  };

  BaseDialogLayoutAppearWrapper.propTypes = {
    className: PropTypes.string,
    closed: PropTypes.bool,
    animated: PropTypes.bool,
  };

  return BaseDialogLayoutAppearWrapper;
}
